module.exports = "<igo-list [navigation]=\"false\" [selection]=\"true\">\r\n  <ng-template ngFor let-currentFilter [ngForOf]=\"this.datasource.options.ogcFilters.interfaceOgcFilters\">\r\n    <igo-ogc-filter-form igoListItem [color]=\"color\" [currentFilter]=\"currentFilter\" [datasource]=\"datasource\">\r\n    </igo-ogc-filter-form>\r\n  </ng-template>\r\n  <ng-content></ng-content>\r\n</igo-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/filter/ogc-filterable-form/ogc-filterable-form.component.html
// module id = 1025
// module chunks = 0